module.exports = __webpack_public_path__ + "open-sans-bold.49a3d5afd563a8a3bbed.woff";


//////////////////
// WEBPACK FOOTER
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/assets/fonts/google/open-sans-bold.woff
// module id = njw4
// module chunks = 1